import { useParams } from "react-router-dom";
import ErrorPage from "pages/error/ErrorPage";
import { findPromotionPage } from "./promotionRegistry";

/**
 * `/promotion/:name` · `/promotion/:name/:sub` 공용 진입점.
 * 레지스트리에 없는 이름이거나 하위 화면이 정의되지 않았으면 404를 보여준다.
 */
function PromotionRoute() {
    const { name, sub } = useParams();
    const entry = findPromotionPage(name);
    const Page = sub ? entry?.sub : entry?.index;

    if (!Page) return <ErrorPage status={404} />;

    return <Page />;
}

export default PromotionRoute;
